import { render, staticRenderFns } from "./ClassSelector.vue?vue&type=template&id=faea452e&scoped=true"
import script from "./ClassSelector.vue?vue&type=script&lang=js"
export * from "./ClassSelector.vue?vue&type=script&lang=js"
import style0 from "./ClassSelector.vue?vue&type=style&index=0&id=faea452e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faea452e",
  null
  
)

export default component.exports